export const COUNT_VIEWS_OFFER = "offer_views";
export const COOKIE_PATH = "/";
export const COOKIE_MAX_AGE_DAYS = 30;
export const COOKIE_MAX_AGE_SECONDS = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
export const MAX_VIEWS = 10;